import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFederalBankHoliday = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	viewBox: "0 0 320 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7990_29036)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M283.488 108.125C275.491 72.9305 250.983 80.9239 244.343 36.4828C240.579 11.2922 207.971 0.825803 187.494 0.627708C151.405 0.285545 116.807 32.4544 80.8518 45.9908C37.5735 62.2766 1.18455 85.0339 45.1876 111.909C73.9371 129.467 175.372 148.952 228.506 151.528C264.745 153.256 288.845 131.698 283.488 108.125Z",
				fill: "#DFE8FD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M133.461 54.5352H257.391",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M259.328 124.244H133.461V135.863H259.328V124.244Z",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M249.645 54.5352H141.206V62.2808H249.645V54.5352Z",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M222.535 64.2158V124.245",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M239.963 64.2158V124.245",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M187.68 64.2158V124.245",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205.108 64.2158V124.245",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M152.825 64.2158V124.245",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M195.427 13.8877L133.461 42.9192",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M257.391 42.9023L195.426 13.8708",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M133.461 42.917V54.5355",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M257.391 42.917V54.5355",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M170.253 64.2158V124.245",
				stroke: "#2C64EF",
				strokeWidth: 3.15067,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M195.426 27.0635C199.903 27.0635 203.533 30.6929 203.533 35.1699C203.533 39.6471 199.903 43.2773 195.426 43.2773C190.949 43.2771 187.319 39.647 187.319 35.1699C187.319 30.693 190.949 27.0637 195.426 27.0635Z",
				stroke: "#2C64EF",
				strokeWidth: 3.15067
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter0_d_7990_29036)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						x: 42.6667,
						y: 48.2461,
						width: 133.333,
						height: 102.755,
						rx: 8.26446,
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 86.3174,
						y: 77.7842,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 103.403,
						y: 77.7842,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 120.479,
						y: 77.7842,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 137.564,
						y: 77.7842,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 154.64,
						y: 77.7842,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 52.1658,
						y: 94.8613,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 69.2412,
						y: 94.8613,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 86.3174,
						y: 94.8613,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 103.403,
						y: 94.8613,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 120.479,
						y: 94.8613,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#A0B9F8"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 137.564,
						y: 94.8613,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 154.64,
						y: 94.8613,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 52.1658,
						y: 111.944,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 52.1658,
						y: 129.021,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 69.2412,
						y: 111.944,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 69.2412,
						y: 129.021,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 86.3174,
						y: 111.944,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 86.3174,
						y: 129.021,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 103.403,
						y: 111.944,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 103.403,
						y: 129.021,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 120.479,
						y: 111.944,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 120.479,
						y: 129.021,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 137.564,
						y: 111.944,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 154.64,
						y: 111.944,
						width: 12.9477,
						height: 12.9477,
						rx: 1.15377,
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M42.6667 56.5106C42.6667 51.9462 46.3669 48.2461 50.9312 48.2461H167.736C172.3 48.2461 176 51.9462 176 56.5106V70.2847H42.6667V56.5106Z",
						fill: "#2C64EF"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						cx: 62.5056,
						cy: 59.8872,
						rx: 4.40771,
						ry: 4.40771,
						fill: "#163278"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						cx: 124.761,
						cy: 59.8872,
						rx: 4.40771,
						ry: 4.40771,
						fill: "#163278"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						cx: 93.6384,
						cy: 59.8872,
						rx: 4.40771,
						ry: 4.40771,
						fill: "#163278"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						cx: 155.894,
						cy: 59.8872,
						rx: 4.40771,
						ry: 4.40771,
						fill: "#163278"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 60.5688,
						y: 38.4004,
						width: 3.85675,
						height: 23.1405,
						rx: 1.92837,
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 122.824,
						y: 38.4004,
						width: 3.85675,
						height: 23.1405,
						rx: 1.92837,
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 91.7017,
						y: 38.4004,
						width: 3.85675,
						height: 23.1405,
						rx: 1.92837,
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 153.957,
						y: 38.4004,
						width: 3.85675,
						height: 23.1405,
						rx: 1.92837,
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M118.858 93.7812C123.895 99.0646 128.931 104.348 131.577 107.09C134.224 109.831 134.326 109.871 134.46 109.939",
						stroke: "#163278",
						strokeWidth: 2.30754,
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M134.9 94.1396C134.882 94.1396 134.864 94.1396 132.574 95.8866C130.285 97.6335 125.725 101.127 122.833 103.555C119.941 105.983 118.856 107.239 117.738 108.532",
						stroke: "#163278",
						strokeWidth: 2.30754,
						strokeLinecap: "round"
					})
				]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_7990_29036",
		x: 33.4366,
		y: 31.4778,
		width: 151.794,
		height: 131.061,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 2.30754 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.61507 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_7990_29036"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_7990_29036",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7990_29036",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 320,
			height: 160,
			fill: "white"
		})
	})] })]
});
const ForwardRef = forwardRef(SvgFederalBankHoliday);
export { ForwardRef as ReactComponent };
